import { SPEND, BALANCE, DEPOSIT } from '~/components/limits/constants';

export type LimitResponseType = {
	PARAM_PLAYER_UNVERIFIED_REASON_ID: number;
	PARAM_MAX_OPERATION: string;
	responsibleGamingLimitType: string;
	PARAM_SCHUFA_CONSENT_NEEDED: boolean;
	PARAM_SCHUFA_MONTHLY_REMAINING_AMT: string;
};

export type SpendLimitMetaType = {
	lastCheck: string;
	lastStatus: string;
	limit: number;
	iframeUrl: string;
	caseId: string;
};

export const LIMIT_POPUP_ACTIONS = {
	VIEW: 'view',
	CTA_CLICK: 'cta-click',
	CLOSE: 'close'
} as const;

export type LimitPopupAction = (typeof LIMIT_POPUP_ACTIONS)[keyof typeof LIMIT_POPUP_ACTIONS];

export type LimitType = typeof SPEND | typeof BALANCE | typeof DEPOSIT;
